<template>
    <div v-wechat-title="title">
        <crud-facecade
            ref="use-package-list"
            :url="url"
            :columns="columnList"
            :tableHeight="tableHeight"
            :buttons="[]"
            dialogWidth="65%"
            class="form-table-h360"
            :sort="true"
            :defaultSort="{ prop: 'valid_date' }"
            :addButton="{ enabled: false, permission: 'default' }"
            :updateButton="{ enabled: false, permission: 'default' }"
            @loadingCollectionView="loadingCollectionView"
            @loadingReturnView="loadingReturnView"
            @loadingStockOutView="loadingStockOutView"
            @LoadingbatchPickingView="LoadingbatchPickingView"
            @LoadingbatchReturnView="LoadingbatchReturnView"
        >
            <slot slot="filter">
                <el-col :span="3">
                    <item-input type="select" v-model="timeType" :options="timeTypes" placeholder="时间类型"></item-input>
                </el-col>
                <el-col :span="7">
                    <item-input type="daterange" v-model="rdate" :noPadding="true"></item-input>
                </el-col>
                <el-col :md="6" :lg="4" :xl="3">
                    <item-input type="select" v-model="dic_operating_ward_id" :options="operation_ward_auth" placeholder="请选择区域"></item-input>
                </el-col>
                <el-col :span="4">
                    <item-input type="multiselect" v-model="packagestatus" :options="enum_packagestatus" :clearable="true" placeholder="状态"></item-input>
                </el-col>
            </slot>
            <slot slot="filter-after">
                <el-col :span="18" v-if="packageBatchScan != 1">
                    <item-input type="scan" v-model="internalcode" placeholder="请扫码/输入条码号" :autofocus="true"></item-input>
                </el-col>
                <el-button v-if="packageBatchScan == 1 && isHavePermissions(`collect`)" type="primary" size="mini" @click="LoadingbatchPickingView">扫码领用</el-button>
                <el-button v-if="packageBatchScan == 1 && isHavePermissions(`return`)" type="primary" size="mini" @click="LoadingbatchReturnView">扫码归还</el-button>
                <el-button v-if="isHavePermissions(`print_all`)" type="primary" size="mini" @click="print">打印</el-button>
            </slot>
        </crud-facecade>
        <form-dialog title="器械包领用" width="50%" class="form-table-h360" :columns="receiveColumns" :data="receive.data" :visible.sync="receive.dialogFormVisible" @confirm="collected"></form-dialog>
        <form-dialog
            title="器械包归还"
            width="50%"
            class="form-table-h360"
            :columns="returneColumns"
            :data="returnInfo.data"
            :visible.sync="returnInfo.dialogFormVisible"
            @confirm="returnPackage"
        ></form-dialog>
        <form-dialog :title="stockOut.title" :data="stockOut.data" :visible.sync="stockOut.dialogFormVisible" :columns="stockOut.columns" @confirm="saveStockOut"></form-dialog>
        <cus-dialog class="form-table-h380" title="批量领用" :visible.sync="batchPickingView.dialogFormVisible" :close-on-click-modal="false" @confirm="formbatchPicking" width="40%">
            <cus-form ref="form-batchPicking" :data="batchPickingViewData" :columns="batchPickingColumns" @extrabutton-click="ExtraButtonClick" @confirm="batchPicking"></cus-form>
        </cus-dialog>
        <cus-dialog class="form-table-h380" title="批量归还" :visible.sync="batchReturnView.dialogFormVisible" :close-on-click-modal="false" @confirm="formbatchReturn" width="40%">
            <cus-form ref="form-batchReturn" :data="batchReturnViewData" :columns="batchReturnColumns" @extrabutton-click="ExtraButtonClick" @confirm="batchReturn"></cus-form>
        </cus-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: `InstrumentPackageUsed`,
    data() {
        let me = this
        return {
            title: `器械包领用归还`,
            o_dic_operating_ward_id: undefined,
            internalcode: undefined,
            workerList: [],
            packagestatus: [0],
            timeType: `入库时间`,
            timeTypes: [
                { value: `入库时间`, label: `入库时间` },
                { value: `领用时间`, label: `领用时间` },
                { value: `归还时间`, label: `归还时间` },
                { value: `出库时间`, label: `出库时间` }
            ],
            isWorkerByDuty: this.$root.IsWorkerByDuty,
            issetoperatingward: false,
            enum_package: [],
            allpackages: [],
            allbatchpackages: [],
            receivers: [],
            packageBatchScan: 0,
            rdate: [
                this.$moment().add(-7, `days`).format(`YYYY/MM/DD`),
                this.$moment()
                    .add(1, `days`)
                    .format(`YYYY/MM/DD`)
            ],
            enum_packagestatus: [
                { value: 0, label: `已入库` },
                { value: -1, label: `已领用` },
                { value: 1, label: `已使用` },
                { value: 3, label: `已出库` }
            ],
            stockOut: {
                title: `出库登记`,
                dialogFormVisible: false,
                data: {},
                packageId: 0,
                columns: [
                    {
                        type: `select`,
                        prop: `out_reason`,
                        label: `出库原因`,
                        config: {
                            allowCreate: true
                        },
                        options: (that, { row }) => {
                            return (me.sys_enums.Enum_PackageOutReason || []).map(x => {
                                return {
                                    label: x.label,
                                    value: x.label
                                }
                            })
                        },
                        validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                    }
                ]
            },
            receive: {
                dialogFormVisible: false,
                data: {},
                packageId: 0
            },
            returnInfo: {
                dialogFormVisible: false,
                data: {},
                packageId: 0
            },
            batchPickingView: {
                dialogFormVisible: false
            },
            batchPickingViewData: {},
            batchReturnView: {
                dialogFormVisible: false
            },
            batchReturnViewData: {},
            url: {
                baseURL: `/api/Nursing/UsePackage`,
                get: () => {
                    return this.loadUsePackages()
                }
            }
        }
    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
            this.$store.dispatch(`ADD_CURRENTUSER`)
        }
        this.$store.dispatch(`sysuser/ADD_WORKERS`)
        this.loadPackages()
        this.loadPackageBatchScan()
    },
    computed: {
        ...mapGetters([`sysuser/workers`, `permissions`, `ward_auth`, `currentUser`, `sys_enums`, `operation_ward_auth`, `recovery_ward_auth`, `active_ward`, `screenHeight`]),
        tableHeight() {
            return (this.screenHeight && this.screenHeight - 190) || 0
        },
        workers() {
            return this[`sysuser/workers`]
        },
        // eslint-disable-next-line vue/no-dupe-keys
        dic_operating_ward_id: {
            get: function() {
                if (!this.issetoperatingward && this.active_ward && _.startsWith(this.active_ward.value, `ow_`)) {
                    this.o_dic_operating_ward_id = this.active_ward.origion
                }
                return this.o_dic_operating_ward_id
            },
            set: function(v) {
                this.o_dic_operating_ward_id = v
                this.issetoperatingward = true
            }
        },
        operationRoom() {
            let that = this
            let rooms = []
            if (this.operation_ward_auth) {
                let ward = _.filter(this.operation_ward_auth, { value: that.dic_operating_ward_id })
                if (ward && ward[0] && ward[0].operation_room) {
                    rooms =
                        ward[0].operation_room.map(d => {
                            d.code = ``
                            return d
                        }) || []
                }
            }
            return rooms
        },

        columnList() {
            let me = this
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isListable: false,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    isKey: true
                },
                {
                    type: `select`,
                    prop: `dic_operating_ward_id`,
                    label: `手术区`,
                    width: `100`,
                    options: this.operation_ward_auth,
                    isListable: true
                },
                {
                    type: `select`,
                    prop: `dic_instrument_package_id`,
                    label: `器械包`,
                    width: `150`,
                    isListable: true,
                    options: this.enum_package,
                    searchable: true
                },
                {
                    type: `string`,
                    prop: `internal_code`,
                    label: `条码号`,
                    width: `150`,
                    isListable: true,
                    searchable: true
                },
                {
                    type: `select`,
                    prop: `enum_package_status`,
                    label: `状态`,
                    width: `100`,
                    options: this.enum_packagestatus,
                    sortable: true,
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `stock_in_time`,
                    label: `入库时间`,
                    width: `140`,
                    sortable: true,
                    isListable: true
                },
                {
                    type: `date`,
                    prop: `clean_date`,
                    label: `消毒日期`,
                    width: `100`,
                    sortable: true,
                    isListable: true
                },
                {
                    type: `date`,
                    prop: `valid_date`,
                    label: `失效日期`,
                    width: `100`,
                    sortable: true,
                    isListable: true
                },
                {
                    type: `select`,
                    prop: `dic_operating_room_id`,
                    label: `手术间`,
                    width: `100`,
                    isListable: true,
                    searchable: true,
                    options: this.operationRoom
                },
                {
                    type: `select`,
                    prop: `receiver_id`,
                    label: `领用人`,
                    width: `100`,
                    isListable: false,
                    searchable: true,
                    options: this.receivers
                },
                {
                    type: `string`,
                    prop: `receiver`,
                    label: `领用人`,
                    width: `100`,
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `receive_date`,
                    label: `领用时间`,
                    width: `140`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `returnee`,
                    label: `归还人`,
                    width: `100`,
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `return_date`,
                    label: `归还时间`,
                    width: `140`,
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `stock_out_time`,
                    label: `出库时间`,
                    width: `140`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `out_reason`,
                    label: `出库原因`,
                    width: `100`,
                    isListable: true
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    width: `150`,
                    isListable: me.isHavePermissions(`collect`) || me.isHavePermissions(`return`) || me.isHavePermissions(`out`),
                    readonly: false,
                    options: function(that, { row }) {
                        let btns = []
                        if (row.enum_package_status == 0 && me.isHavePermissions(`collect`) && me.$moment(row.valid_date).isAfter(me.$moment())) {
                            btns.push({
                                class: `is-plain`,
                                label: `领用`,
                                icon: ``,
                                type: `primary`,
                                emit: `loadingCollectionView`,
                                permission: `default`
                            })
                        } else if (row.enum_package_status == -1 && me.isHavePermissions(`return`)) {
                            btns.push({
                                class: `is-plain`,
                                label: `归还`,
                                icon: ``,
                                type: `primary`,
                                emit: `loadingReturnView`,
                                permission: `default`
                            })
                        }
                        if (row.enum_package_status != 1 && row.enum_package_status != 3 && me.isHavePermissions(`out`)) {
                            btns.push({
                                class: `is-plain`,
                                label: `出库`,
                                icon: ``,
                                type: `danger`,
                                emit: `loadingStockOutView`,
                                permission: `default`
                            })
                        }

                        return btns
                    },
                    fixed: `right`
                }
            ]
        },
        receiveColumns() {
            return [
                {
                    type: `table2`,
                    prop: `items`,
                    label: `器械列表`,
                    isEditable: true,
                    isCreatable: true,
                    options: [
                        {
                            type: `string`,
                            prop: `id`,
                            label: `id`,
                            isKey: true
                        },
                        {
                            type: `string`,
                            prop: `name`,
                            label: `器械名称`,
                            isListable: true
                        },
                        {
                            type: `number`,
                            prop: `quantity`,
                            label: `器械数量`,
                            width: `150`,
                            isListable: true
                        },
                        {
                            type: `string`,
                            prop: `code`,
                            label: `器械编号`,
                            width: `150`,
                            isListable: true
                        }
                    ],
                    colspan: 24,
                    default: [],
                    config: {
                        height: this.screenHeight - 400
                    }
                },
                {
                    type: `textarea`,
                    prop: `receive_remark`,
                    label: `备注`,
                    config: {
                        minRows: 2
                    },
                    readonly: false,
                    colspan: 24
                },
                {
                    type: `select`,
                    prop: `receiver_id`,
                    label: `领用人`,
                    readonly: false,
                    colspan: 6,
                    default: this.currentUser && this.currentUser.dic_worker_id,
                    options: this.workerList,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `select`,
                    prop: `dic_operating_room_id`,
                    label: `手术间`,
                    readonly: false,
                    colspan: 6,
                    options: this.operationRoom
                }
            ]
        },
        returneColumns() {
            return [
                {
                    type: `table2`,
                    prop: `items`,
                    label: `器械列表`,
                    isEditable: true,
                    isCreatable: true,
                    options: [
                        {
                            type: `string`,
                            prop: `id`,
                            label: `id`,
                            isKey: true
                        },
                        {
                            type: `string`,
                            prop: `name`,
                            label: `器械名称`,
                            isListable: true
                        },
                        {
                            type: `number`,
                            prop: `quantity`,
                            label: `器械数量`,
                            width: `150`,
                            isListable: true
                        },
                        {
                            type: `string`,
                            prop: `code`,
                            label: `器械编号`,
                            width: `150`,
                            isListable: true
                        }
                    ],
                    colspan: 24,
                    default: [],
                    config: {
                        height: this.screenHeight - 400
                    }
                },
                {
                    type: `textarea`,
                    prop: `return_remark`,
                    label: `备注`,
                    config: {
                        minRows: 2
                    },
                    readonly: false,
                    colspan: 24
                },
                {
                    type: `select`,
                    prop: `returnee_id`,
                    label: `归还人`,
                    readonly: false,
                    colspan: 12,
                    options: this.workerList,
                    default: this.currentUser && this.currentUser.dic_worker_id,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `datetime`,
                    prop: `return_date`,
                    label: `归还时间`,
                    readonly: false,
                    colspan: 12,
                    default: _.now(),
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                }
            ]
        },
        batchPickingColumns() {
            let me = this
            return [
                {
                    type: `scan`,
                    prop: `internal_code`,
                    label: `条码号`,
                    colspan: 20,
                    placeholder: `请扫码或者手动输入条码号`,
                    autofocus: true,
                    change: function($that, { row }) {
                        // 匹配出数据
                        let Info = _.filter(me.allbatchpackages, function(i) {
                            return i.enum_package_status == 0 && i.IsCollection == 1 && i.internal_code.toUpperCase() == row.internal_code.trim().toUpperCase()
                        })
                        if (Info && Info[0]) {
                            let rowInfo = row.items && _.filter(row.items, function(i) {
                                return i.internal_code.toUpperCase() == Info[0].internal_code.trim().toUpperCase()
                            })
                            if (!row.items || rowInfo.length == 0) {
                                me.batchPickingViewData.items.push(Info[0])
                            } else {
                                me.$message.warning(`该条码列表中已包含,请勿重复录入！`)
                            }
                        } else {
                            me.$message.warning(`该条码不存在或对应器械包不允许领用！`)
                        }
                        me.$refs[`form-batchPicking`].$refs.ItemInput[0].scan_val = ``
                    },
                    config: {
                        autofocus: true
                    }
                },
                {
                    type: `table2`,
                    prop: `items`,
                    label: `清单`,
                    isEditable: true,
                    isCreatable: true,
                    options: [
                        {
                            type: `string`,
                            prop: `id`,
                            label: `id`,
                            isKey: true
                        },
                        {
                            type: `string`,
                            prop: `internal_code`,
                            label: `器械编号`,
                            isListable: true
                        },
                        {
                            type: `select`,
                            prop: `dic_instrument_package_id`,
                            label: `名称`,
                            width: `150`,
                            options: me.enum_package,
                            isListable: true
                        },
                        {
                            type: `buttongroup`,
                            prop: `oper`,
                            label: `操作`,
                            width: `150`,
                            isListable: true,
                            readonly: false,
                            options: function(that, { row }) {
                                return [
                                    {
                                        class: `is-plain`,
                                        label: `移除`,
                                        icon: ``,
                                        type: `danger`,
                                        emit: `removerow1`,
                                        permission: `default`
                                    }
                                ]
                            },
                            fixed: `right`
                        }
                    ],
                    colspan: 24,
                    default: [],
                    config: {
                        height: this.screenHeight - 400
                    }
                },
                {
                    type: `select`,
                    prop: `receiver_id`,
                    label: `领用人`,
                    readonly: false,
                    colspan: 10,
                    default: this.currentUser && this.currentUser.dic_worker_id,
                    options: this.workerList,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `select`,
                    prop: `dic_operating_room_id`,
                    label: `手术间`,
                    readonly: false,
                    colspan: 10,
                    options: this.operationRoom
                }
            ]
        },
        batchReturnColumns() {
            let me = this
            return [
                {
                    type: `scan`,
                    prop: `internal_code`,
                    label: `条码号`,
                    colspan: 20,
                    placeholder: `请扫码或者手动输入条码号`,
                    autofocus: true,
                    change: function($that, { row }) {
                        if (!$that.emitNewScan) {
                            $that.emitNewScan = _.debounce(function() {
                                $that.$emit(`new-scan`, row)
                            }, 1000)
                        }
                        $that.emitNewScan()
                        // 匹配出数据
                        let Info = _.filter(me.allbatchpackages, function(i) {
                            return i.enum_package_status == -1 && i.internal_code.toUpperCase() == row.internal_code.trim().toUpperCase()
                        })
                        if (Info && Info[0]) {
                            let rowInfo = row.items && _.filter(row.items, function(i) {
                                return i.internal_code.toUpperCase() == Info[0].internal_code.trim().toUpperCase()
                            })
                            if (!row.items || rowInfo.length == 0) {
                                me.batchReturnViewData.items.push(Info[0])
                            } else {
                                me.$message.warning(`该条码列表中已包含,请勿重复录入！`)
                            }
                        } else {
                            me.$message.warning(`该条码不存在或对应器械包不允许归还！`)
                        }
                        me.$refs[`form-batchReturn`].$refs.ItemInput[0].scan_val = ``
                    },
                    config: {
                        autofocus: true
                    }
                },
                {
                    type: `table2`,
                    prop: `items`,
                    label: `清单`,
                    isEditable: true,
                    isCreatable: true,
                    options: [
                        {
                            type: `string`,
                            prop: `id`,
                            label: `id`,
                            isKey: true
                        },
                        {
                            type: `string`,
                            prop: `internal_code`,
                            label: `器械编号`,
                            isListable: true
                        },
                        {
                            type: `select`,
                            prop: `dic_instrument_package_id`,
                            label: `名称`,
                            width: `150`,
                            options: me.enum_package,
                            isListable: true
                        },
                        {
                            type: `buttongroup`,
                            prop: `oper`,
                            label: `操作`,
                            width: `150`,
                            isListable: true,
                            readonly: false,
                            options: function(that, { row }) {
                                return [
                                    {
                                        class: `is-plain`,
                                        label: `移除`,
                                        icon: ``,
                                        type: `danger`,
                                        emit: `removerow2`,
                                        permission: `default`
                                    }
                                ]
                            },
                            fixed: `right`
                        }
                    ],
                    colspan: 24,
                    default: [],
                    config: {
                        height: this.screenHeight - 400
                    }
                },
                {
                    type: `select`,
                    prop: `returnee_id`,
                    label: `归还人`,
                    readonly: false,
                    colspan: 12,
                    options: this.workerList,
                    default: this.currentUser && this.currentUser.dic_worker_id,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `datetime`,
                    prop: `return_date`,
                    label: `归还时间`,
                    readonly: false,
                    colspan: 12,
                    default: _.now(),
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                }
            ]
        }
    },
    methods: {
        // loadWorkerList(q, row) {
        //     let r = {
        //         operatingWardId: this.dic_operating_ward_id,
        //         keyword: q && q.keyword
        //     }
        //     return new Promise(resolve => {
        //         let req = this.myaxios.get(`/api/AcisSystem/Worker/SearchForOperatingWard`, r)
        //         req.then(data => {
        //             resolve(data)
        //         })
        //     })
        // },
        loadWorkerList() {
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/Worker/SearchForOperatingWard?operatingWardId=${this.dic_operating_ward_id || -1}`)
                req.then(data => {
                    this.workerList = data
                    resolve(data)
                })
            })
        },
        ExtraButtonClick(target) {
            this[target.emit] && this[target.emit](target)
        },
        isHavePermissions(permiskey) {
            return this.permissions && this.permissions.findIndex(item => item.permission === `package:${permiskey}`) != -1
        },
        loadPackageBatchScan() {
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=PackageBatchScan`)
                req.then(data => {
                    if (data && data.value && data.value.trim()) {
                        this.packageBatchScan = parseInt(data.value)
                    }
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        loadPackages() {
            let that = this
            let req = that.myaxios.get(`/api/AcisSystem/Package/Get`)
            req.then(data => {
                that.enum_package = _.filter(data, { is_deleted: false }).map(d => {
                    return {
                        value: d.id,
                        label: d.is_external ? d.name + `【外】` : d.name,
                        jianpin: d.abbr
                    }
                })
            }).catch(e => {
                that.enum_package = []
            })
        },
        loadUsePackages() {
            return new Promise((resolve, reject) => {
                let that = this
                let status = ``
                if (this.packagestatus && this.packagestatus.length > 0) {
                    status = this.packagestatus.join(`,`)
                }
                let req1 = this.myaxios.get(
                    `/api/Nursing/UsePackage/GetUsePackages?wardid=${this.dic_operating_ward_id}&status=${status}&timeType=${this.timeType}&from=${this.rdate[0]}&to=${this.rdate[1]}`
                )
                let req2 = this.myaxios.get(
                    `/api/Nursing/UsePackage/GetAllUsePackages?wardid=${this.dic_operating_ward_id}`
                )
                this.myaxios
                    .all(req1, req2)
                    .then(([data, data2]) => {
                        data = data.map(d => {
                            d.class_name = this.$moment(d.valid_date).isAfter(this.$moment()) ? `` : `outofdate` // 超期的日期显示红色 ，css控制
                            d.IsCollection = d.class_name == `outofdate` ? 0 : 1
                            return d
                        })
                        data2 = data2.map(d => {
                            d.class_name = this.$moment(d.valid_date).isAfter(this.$moment()) ? `` : `outofdate` // 超期的日期显示红色 ，css控制
                            d.IsCollection = d.class_name == `outofdate` ? 0 : 1
                            return d
                        })
                        if (this.internalcode && this.internalcode.trim() != ``) {
                            data = _.filter(data, function(i) {
                                return i.internal_code.toUpperCase() == that.internalcode.trim().toUpperCase()
                            })
                        }
                        that.allpackages = data
                        that.allbatchpackages = data2

                        var sectionList = _.filter(data, function(i) {
                            return i.receiver_id > 0
                        })
                        let worker = _.cloneDeep(that.workers)
                        that.receivers = _.reduce(
                            _.groupBy(sectionList,
                                `receiver_id`
                            ),
                            function(result, value, key) {
                                let sOne = _.find(worker, d => {
                                    return d.id == key
                                })
                                if (sOne) {
                                    result.push({
                                        value: sOne.id,
                                        label: sOne.name,
                                        jianpin: sOne.abbr
                                    })
                                }
                                return result
                            },
                            []
                        )

                        that.loadWorkerList()
                        resolve(data)
                    })
                    .catch(e => {
                        console.log(e)
                        reject(e)
                    })
            })
        },
        loadingCollectionView({ row }) {
            let r = row
            this.receive.packageId = row.id
            let req
            if (r.id >= 0) {
                req = this.myaxios.get(`/api/AcisSystem/Package/Get/${r.dic_instrument_package_id}`)
            } else {
                req = Promise.resolve([])
            }
            req.then(data => {
                r.items = data && data.instruments
                this.receive.data = r
                this.receive.dialogFormVisible = true
            })
        },
        collected(row) {
            let that = this
            return new Promise((resolve, reject) => {
                let requestData = {
                    id: that.receive.packageId,
                    enum_package_status: -1, // 领用
                    enum_package_status_old: row.enum_package_status,
                    receive_remark: row.receive_remark,
                    receiver_id: row.receiver_id,
                    dic_operating_room_id: row.dic_operating_room_id
                }
                let req = that.myaxios.put(`/api/Nursing/UsePackage/UsePackagePut?type=1`, requestData)
                req.then(data => {
                    that.receive.dialogFormVisible = false
                    that.$refs[`use-package-list`].ReloadListData()
                    resolve(data)
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        loadingReturnView({ row }) {
            let r = row
            this.returnInfo.packageId = row.id
            let req
            if (r.id >= 0) {
                req = this.myaxios.get(`/api/AcisSystem/Package/Get/${r.dic_instrument_package_id}`)
            } else {
                req = Promise.resolve([])
            }
            req.then(data => {
                r.items = data && data.instruments
                this.returnInfo.data = r
                this.returnInfo.dialogFormVisible = true
            })
        },
        returnPackage(row) {
            let that = this
            return new Promise((resolve, reject) => {
                let requestData = {
                    id: that.returnInfo.packageId,
                    enum_package_status: 0, // 入库
                    enum_package_status_old: row.enum_package_status,
                    return_remark: row.return_remark,
                    returnee_id: row.returnee_id,
                    clean_date: row.clean_date,
                    return_date: row.return_date,
                    dic_instrument_package_id: row.dic_instrument_package_id
                }
                let req = that.myaxios.put(`/api/Nursing/UsePackage/UsePackagePut?type=2`, requestData)
                req.then(data => {
                    that.returnInfo.dialogFormVisible = false
                    that.$refs[`use-package-list`].ReloadListData()
                    resolve(data)
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        loadingStockOutView({ row }) {
            this.stockOut.dialogFormVisible = true
            this.stockOut.packageId = row.id
        },
        saveStockOut(row) {
            let that = this
            return new Promise((resolve, reject) => {
                let requestData = {
                    id: that.stockOut.packageId,
                    enum_package_status: 3, // 出库
                    enum_package_status_old: row.enum_package_status,
                    out_reason: row.out_reason
                }
                let req = that.myaxios.put(`/api/Nursing/UsePackage/UsePackagePut?type=3`, requestData)
                req.then(data => {
                    that.stockOut.dialogFormVisible = false
                    that.$refs[`use-package-list`].ReloadListData()
                    resolve(data)
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        LoadingbatchPickingView() {
            this.batchPickingView.dialogFormVisible = true
            this.batchPickingViewData = {}
            this.batchPickingViewData.items = []
        },
        formbatchPicking() {
            this.$refs[`form-batchPicking`].confirm()
        },
        formbatchReturn() {
            this.$refs[`form-batchReturn`].confirm()
        },
        batchPicking(row) {
            let that = this
            if (!row.items || row.items.length == 0) {
                that.$message.warning(`请录入待领用器械包！`)
                return
            }
            return new Promise((resolve, reject) => {
                let requestData =
                    row.items &&
                    row.items.map(d => {
                        d.enum_package_status_old = d.enum_package_status
                        d.enum_package_status = -1 // 领用
                        d.receiver_id = row.receiver_id
                        d.dic_operating_room_id = row.dic_operating_room_id
                        return d
                    })
                let req = that.myaxios.put(`/api/Nursing/UsePackage/UsePackagePutMany?type=1`, requestData)
                req.then(data => {
                    that.batchPickingViewData = {}
                    that.batchPickingView.dialogFormVisible = false
                    that.$refs[`use-package-list`].ReloadListData()
                    resolve(data)
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        LoadingbatchReturnView() {
            this.batchReturnView.dialogFormVisible = true
            this.batchReturnViewData = {}
            this.batchReturnViewData.items = []
        },
        batchReturn(row) {
            let that = this
            if (!row.items || row.items.length == 0) {
                that.$message.warning(`请录入待归还器械包！`)
                return
            }
            return new Promise((resolve, reject) => {
                let requestData =
                    row.items &&
                    row.items.map(d => {
                        d.enum_package_status_old = d.enum_package_status
                        d.enum_package_status = 0 // 领用
                        d.returnee_id = row.returnee_id
                        d.clean_date = row.clean_date
                        d.return_date = row.return_date
                        return d
                    })
                let req = that.myaxios.put(`/api/Nursing/UsePackage/UsePackagePutMany?type=2`, requestData)
                req.then(data => {
                    row = {}
                    that.batchReturnViewData = {}
                    that.batchReturnView.dialogFormVisible = false
                    that.$refs[`use-package-list`].ReloadListData()
                    resolve(data)
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        removerow1({ index, row }) {
            // 移除一行
            this.batchPickingViewData.items.splice(index, 1)
        },
        removerow2({ index, row }) {
            // 移除一行
            this.batchReturnViewData.items.splice(index, 1)
        },
        print(command) {
            let doc = `QXGL001`
            let docId = this.$root.DOCUMENT[doc]
            let req = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=isShowSendPrintMessage`)
            req.then(isShow => {
                this.$store.dispatch(`PRINT_PDF`, {
                    host: this.$root.DOCSERVICE_BASE,
                    params: Object.assign(
                        {
                            docid: docId,
                            id1: ``,
                            objId: `${this.timeType}`,
                            from: this.$moment(this.rdate[0]).format(`YYYYMMDDHHmm`),
                            to: this.$moment(this.rdate[1]).format(`YYYYMMDDHHmm`)
                        },
                        { isShowSendPrintMessage: isShow.value }
                    )
                })
            }).catch(e => {
                console.log(e)
            })
        }
    },
    watch: {
        dic_operating_ward_id: function() {
            this.$refs[`use-package-list`].ReloadListData()
        },
        packagestatus: function() {
            this.$refs[`use-package-list`].ReloadListData()
        },
        internalcode: function() {
            this.$refs[`use-package-list`].ReloadListData()
        },
        rdate: function() {
            this.$refs[`use-package-list`].ReloadListData()
        },
        timeType: function() {
            this.$refs[`use-package-list`].ReloadListData()
        }
    }
}
</script>
<style>
.el-form-item.item.name p {
    font-weight: bold;
    color: black;
}
.outofdate .valid_date {
    color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/Dictionary/Instrument/UsePackage.vue